import { FileTextOutlined } from "@ant-design/icons";
import Button, { ButtonProps } from "../../button";
import { ModalProps, useModal } from "@/shared/modal";
import { DocumentModal } from "./document-modal";
import { twMerge } from "tailwind-merge";
import { FileForDocumentButtonFragment } from "gql/graphql";
import { useDocumentPreview } from "@/shared/form/button/document-button/model/use-document-preview";

export type DocumentButtonProps = Omit<ButtonProps, "href"> & {
  file: FileForDocumentButtonFragment;
  name?: string;
  modalProps?: ModalProps;
};

export function DocumentButton({
  file,
  name,
  modalProps,
  className,
  children,
  ...rest
}: DocumentButtonProps) {
  const { close, open, openModal } = useModal();
  const { uri, isPreviewAvailable } = useDocumentPreview(file);

  if (!uri) {
    return null;
  }

  return (
    <>
      <Button
        onClick={isPreviewAvailable ? open : undefined}
        icon={<FileTextOutlined />}
        type="link"
        href={!isPreviewAvailable ? uri : undefined}
        title={name}
        className={twMerge(
          className,
          "[&_span]:max-w-[200px] [&_span]:overflow-hidden [&_span]:text-ellipsis",
        )}
        {...rest}
      >
        {/* `name` остаётся строкой для `title` и заголовка модалки, а на кнопке
            может стоять компонент сущности — иначе он молча терялся. */}
        {children ?? name}
      </Button>

      <DocumentModal
        file={file}
        name={name ?? ""}
        modalProps={{
          onCancel: close,
          open: openModal,
          ...modalProps,
        }}
      />
    </>
  );
}
